import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import SubscriptionPageUI from './SubscriptionPageUI.js'

class SubscriptionPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subscription: null,
      messageList: null,
      errorList: [],
      priceList: null,
    }
  }

  render() {
    return (
      <SubscriptionPageUI
        context={this.props.context}
        subscription={this.state.subscription}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        priceList={this.state.priceList}
        //
        onSubscriptionChange={this.onSubscriptionChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getSubscription(context)
    this.getPrices(context)
    this.getMessages(context)
  }

  getSubscription(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/subscription`,
      cacheKey: CacheKeys.Subscription(context.session.accountId),
      callback: this.getSubscriptionCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSubscriptionCallback = (response) => {
    this.setState({errorList: response.errorList, subscription : response.subscription})
  }

  getPrices(context) {
    let countryCode = context.account.countryCode
    let cacheManager = new CacheManager({
      resource: `/api/pub/prices/countryCodes/${countryCode}`,
      cacheKey: CacheKeys.Prices('pg_acc_sub', countryCode, context.locale),
      callback: this.getPricesCallback,
      ttlInSecs: 3600
    })
    // accountId is not sent when creating new account and subscription
    // accountId is sent when upgrading subscription in existing account
    cacheManager.getObject2(context, {}, {accountId: context.session.accountId})
  }

  getPricesCallback = (response) => {
    this.setState({errorList: response.errorList, priceList: response.priceList})
  }

  onSubscriptionChange = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Subscription(context.session.accountId))
    CacheManager.removeObject(CacheKeys.Account(context.session.accountId))
    this.getSubscription(context)
    this.getAccount(context)
  }

  getAccount = (context) => {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}`,
      cacheKey: CacheKeys.Account(context.session.accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    let context = this.props.context
    context.account = response.account
    context.onContextChange(context)
  }

  getMessages(context) {
    let arr = [
      'c_plan',
      'c_update',
      'c_cancel',
      'c_update_subscription',
      'c_cancel_subscription',
      'c_subscription',
      'c_n_projects',
      'c_update_card',
      //
      'c_billed_daily',
      'c_billed_weekly',
      'c_billed_monthly',
      'c_billed_yearly',
      //
      'c_free_trial',
      'c_trial_ends',
      'c_next_bill_date',
      'c_trial_remaining',
      'c_1_day',
      'c_n_days',
      //
      'c_cancel',
      'c_cancel_sub_confirm',
      'c_yes_cancel',
      'c_do_not_cancel'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_sub', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default SubscriptionPageSF
